import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AuthPage from '../pages/AuthPage';
import FeedPage from '../pages/FeedPage';
import MagicAuthPage from '../pages/MagicAuthPage';
import RegisterPage from '../pages/RegisterPage';
import VetInviteRegisterPage from '../pages/VetInviteRegisterPage';
import OpportunitiesPage from '../pages/OpportunitiesPage';
import DashboardPage from '../pages/DashboardPage';
import ApplicantsPage from '../pages/ApplicantsPage';
import PanelPage from '../pages/PanelPage';
import MyApplicationsPage from '../pages/MyApplicationsPage';
import MyPostingsPage from '../pages/MyPostingsPage';
import ProtectedRoute from '../components/layout/ProtectedRoute';

import CasesPage from '../pages/cases/CasesPage';
import CaseDetailPage from '../pages/cases/CaseDetailPage';
import MyCasesPage from '../pages/cases/MyCasesPage';
import SavedCasesPage from '../pages/cases/SavedCasesPage';
import MyInputsPage from '../pages/cases/MyInputsPage';
import CaseIntakePage from '../pages/cases/CaseIntakePage';
import CaseResponsePage from '../pages/cases/CaseResponsePage';
import DoctorApproachPage from '../pages/cases/DoctorApproachPage';
import ComparisonPage from '../pages/cases/ComparisonPage';
import ChallengePage from '../pages/cases/ChallengePage';
import SubscriptionPage from '../pages/SubscriptionPage';
import ProfilePage from '../pages/ProfilePage';
import ForgotPasswordPage from '../features/auth/components/ForgotPasswordPage';
import SearchPage from '../pages/SearchPage';


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<RegisterPage />} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/vet-register" element={<VetInviteRegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      
      {/* Protected Routes */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute roles={['student']}>
            <DashboardPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/feed" 
        element={
          <ProtectedRoute>
            <FeedPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/posts/:id" 
        element={
          <ProtectedRoute>
            <FeedPage />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/opportunities" 
        element={
          <ProtectedRoute>
            <OpportunitiesPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/opportunities/:id/applicants" 
        element={
          <ProtectedRoute>
            <ApplicantsPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/panels/:panelId" 
        element={
          <ProtectedRoute>
            <PanelPage />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/my-postings" 
        element={
          <ProtectedRoute>
            <MyPostingsPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/my-applications" 
        element={
          <ProtectedRoute>
            <MyApplicationsPage />
          </ProtectedRoute>
        } 
      />

      <Route path="/cases" element={<ProtectedRoute roles={['student']}><CasesPage /></ProtectedRoute>} />
      <Route path="/cases/mine" element={<ProtectedRoute><MyCasesPage /></ProtectedRoute>} />
      <Route path="/cases/saved" element={<ProtectedRoute><SavedCasesPage /></ProtectedRoute>} />
      <Route path="/cases/my-inputs" element={<ProtectedRoute><MyInputsPage /></ProtectedRoute>} />
      <Route path="/cases/:id" element={<ProtectedRoute><CaseDetailPage /></ProtectedRoute>} />
      <Route path="/cases/:id/intake" element={<ProtectedRoute roles={['student']}><CaseIntakePage /></ProtectedRoute>} />
      <Route path="/cases/:id/response" element={<ProtectedRoute roles={['student']}><CaseResponsePage /></ProtectedRoute>} />
      <Route path="/cases/:id/approach" element={<ProtectedRoute roles={['student']}><DoctorApproachPage /></ProtectedRoute>} />
      <Route path="/cases/:id/comparison" element={<ProtectedRoute roles={['student']}><ComparisonPage /></ProtectedRoute>} />
      <Route path="/challenges" element={<ProtectedRoute roles={['student']}><ChallengePage /></ProtectedRoute>} />
      <Route path="/challenges/:id/intake" element={<ProtectedRoute roles={['student']}><CaseIntakePage /></ProtectedRoute>} />
      <Route path="/challenges/:id/response" element={<ProtectedRoute roles={['student']}><CaseResponsePage /></ProtectedRoute>} />
      <Route path="/challenges/:id/approach" element={<ProtectedRoute roles={['student']}><DoctorApproachPage /></ProtectedRoute>} />
      <Route path="/challenges/:id/comparison" element={<ProtectedRoute roles={['student']}><ComparisonPage /></ProtectedRoute>} />
      <Route path="/subscription" element={<ProtectedRoute roles={['student']}><SubscriptionPage /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/search" element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />

      <Route path="/auth/magic" element={<MagicAuthPage />} />

    </Routes>
  );
};

export default AppRoutes;
